export const ATTACHMENT = `
_id
url
type
info`;
